import React from 'react';
import { IndigoAppContextType } from 'app/AppContext';
import Column from 'widgets/blotter/columns/Column';
import ColumnType from 'widgets/blotter/columns/ColumnType';

export const colFmtCellRenderer =
    <C extends ColumnType>(context: IndigoAppContextType, column: Column<C>) =>
    // eslint-disable-next-line react/display-name
    <T,>(props: { value: T }) =>
        props.value !== undefined ? (
            <span>{column.colFmt!(context, props.value)}</span>
        ) : (
            <span />
        );
